import { render } from "./InactiveScreen.vue?vue&type=template&id=c47637a8&scoped=true"
import script from "./InactiveScreen.vue?vue&type=script&lang=js"
export * from "./InactiveScreen.vue?vue&type=script&lang=js"

import "./InactiveScreen.vue?vue&type=style&index=0&id=c47637a8&scoped=true&lang=css"

import exportComponent from "/Users/peterdevos/Apps/visma_reaction_game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47637a8"]])

export default __exports__